<template>
	<div>
		<div class="list_top_box">
			<div class="left_option">
				<h3>Sales & Gross Profit</h3>
				<div class="mgb_5">
					<span>Period Type: </span>
					<select class="tbl_select ssm3_int mgr_10" v-model="unit">
						<option value="DAY">IN MONTH</option>
						<option value="MONTH">IN YEAR</option>
					</select>

					<span>Year: </span>
					<select class="tbl_select sssm_int mgr_10" v-model="year">
						<option v-for="(i, index) in 20" :key="i" :value="thisYear - index">{{ thisYear - index }}</option>
					</select>

					<span>Month: </span>
					<select :disabled="unit === 'MONTH'" class="tbl_select sssm_int mgr_10" v-model="month">
						<option v-for="i in 12" :key="i" :value="i">{{ i }}</option>
					</select>
				</div>
				<div>
					<label class="mgr_5"><input type="radio" v-model="by_sales_group" :value="null" /> Enterprise</label>
					<label class="mgr_10"><input type="radio" v-model="by_sales_group" value="Y" /> By Sales Group</label>

					<span>Sales Group: </span>
					<span class="int_type_no_border mgr_5"><CodeSelect :disabled="!by_sales_group" className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

					<a href="javascript:;" class="search_bt" @click="search">Search</a>
				</div>
			</div>
		</div>
		<div style="overflow: hidden; min-height: 320px; max-height: 320px; position: relative;">
			<b style="position: absolute; top: 5px; right: 20px;">Currency: $</b>
			<GrossProfitGraph class="mgb_10" :unit="unit" :year="year" :month="month" :sales_group_code="sales_group_code" :key="chartKey" @emitSumData="sum_data = $event" />
		</div>
		<div class="bottom_bt_box">
			<p class="col_6">
				Search Period: {{ search_from_date }} ~ {{ search_to_date }}
				<template v-if="search_sales_group"><br />Search Sales Group: {{ search_sales_group }} </template>
			</p>
			<div class="col_6">
				<table>
					<tr v-for="(row, index) in sum_rows" :key="index">
						<td class="al_right">
							<b class="mgr_10">{{ row.label }}:</b>
						</td>
						<td class="al_left">
							<b>{{ row.display }}</b>
						</td>
					</tr>
				</table>

				<!--
				<p class="al_right mgr_10" v-for="(prop, index) in Object.keys(sum_data)" :key="index">
					<b>{{ prop }}: {{ sum_data[prop] | commaSeparated }}</b>
				</p> -->
			</div>
		</div>
	</div>
</template>

<script>
import GrossProfitGraph from '@/views/statistics/grossProfit/GrossProfitGraph.vue';
import CodeSelect from '@/components/common/CodeSelect';
import { apiSelectSalesGroupList } from '@/api/basicinfo/salesgroup.js';
import { toText } from '@/utils/date';
export default {
	data: () => ({
		unit: null,
		year: 0,
		thisYear: 0,
		month: 0,
		chartKey: 0,

		by_sales_group: null,
		sales_group_code: null,
		salesGroups: [],

		search_from_date: null,
		search_to_date: null,
		search_sales_group: null,

		sum_data: {},
	}),
	components: {
		GrossProfitGraph,
		CodeSelect,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		is_arkin() {
			return this.company_id === 'arkin';
		},
		sum_rows() {
			const filters = this.$options.filters;
			const fmt = v => (this.is_arkin ? filters.toCurrency(v) : filters.commaSeparated(v));
			const sale = this.sum_data['SALE'];
			const cost = this.sum_data['COST'];
			const gp = this.sum_data['GROSS PROFIT'];
			const rows = [
				{ label: 'SALE', display: fmt(sale) },
				{ label: 'COST', display: fmt(cost) },
				{ label: 'GROSS PROFIT', display: fmt(gp) },
			];
			if (this.is_arkin) {
				const gp_pct = sale ? ((gp / sale) * 100).toFixed(2) + ' %' : '0.00 %';
				rows.push({ label: 'GROSS PROFIT %', display: gp_pct });
			}
			return rows;
		},
	},
	watch: {
		by_sales_group: {
			handler: function() {
				if (!this.by_sales_group) this.sales_group_code = null;
			},
		},
	},
	methods: {
		search() {
			if (this.by_sales_group && !this.sales_group_code) return this.$toast.error('Please Select Salse Group');

			this.makeDisplayEl();
			this.chartKey++;
		},
		makeDisplayEl() {
			if (this.unit === 'DAY') {
				this.search_from_date = toText(new Date(this.year, this.month - 1, 1), '-');
				this.search_to_date = toText(new Date(this.year, this.month, 0), '-');
			} else if (this.unit === 'MONTH') {
				this.search_from_date = toText(new Date(this.year, 0, 1), '-');
				this.search_to_date = toText(new Date(this.year, 12, 31), '-');
			}

			if (this.by_sales_group && this.sales_group_code) {
				this.search_sales_group = this.salesGroups.find(el => el.code === this.sales_group_code).name;
			} else this.search_sales_group = null;
		},
		async getSalesGroups() {
			const { data } = await apiSelectSalesGroupList({ active_yn: 'Y' });
			this.salesGroups = data.salesGroupList;
		},
		async init() {
			let today = new Date();
			this.unit = 'MONTH';
			this.thisYear = today.getFullYear();
			this.year = today.getFullYear();
			this.month = today.getMonth() + 1;
			this.makeDisplayEl();

			await this.getSalesGroups();
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
